
import { AmbienteInternoPontoForte } from '../types/negocio/AmbienteInternoPontoForte';
import api from './api';
import BaseService from './BaseService';

class AmbienteInternoPontoForteService extends BaseService<AmbienteInternoPontoForte> {

  constructor() {
    super('ambiente-interno-ponto-forte', api);
  }  
 
}

export const ambienteInternoPontoForteService = new AmbienteInternoPontoForteService();